import { render, staticRenderFns } from "./CoverageDash.vue?vue&type=template&id=1baa1e13&scoped=true&"
import script from "./CoverageDash.vue?vue&type=script&lang=js&"
export * from "./CoverageDash.vue?vue&type=script&lang=js&"
import style0 from "./CoverageDash.vue?vue&type=style&index=0&id=1baa1e13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa1e13",
  null
  
)

export default component.exports